import React from 'react';
import Order from '../models/Order'

const OrdersContext = React.createContext();

const OrdersProvider = (props) => {

  const orders = (props && props.value || []).map((o) => Order(o))

  return (
    <OrdersContext.Provider value={orders}>
      {props.children}
    </OrdersContext.Provider>
  );
};

export { OrdersContext, OrdersProvider}
